import React from 'react';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';

export enum MButtonIconState {
  Default = 'Default',
  Hover = 'Hover',
  Active = 'Active',
  Disabled = 'Disabled',
}

export type MButtonIconProps = {
  state?: MButtonIconState;
  aIcon: Pick<AIconProps, 'icon'>;
  size?: AIconProps['size'];
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
};
